import { useEffect } from "react";
import { loadActivePaymentSession } from "../utils/abandonedOrderPayments";
import { handlePaymentTabClose } from "../utils/paymentCloseCleanup";

export function usePaymentCloseGuard(): void {
  useEffect(() => {
    const onPageHide = () => {
      const session = loadActivePaymentSession();
      if (!session || session.completed) return;
      handlePaymentTabClose(session);
    };

    window.addEventListener("pagehide", onPageHide);
    return () => window.removeEventListener("pagehide", onPageHide);
  }, []);
}
